/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyDto } from './CompanyDto';
import {
    CompanyDtoFromJSON,
    CompanyDtoFromJSONTyped,
    CompanyDtoToJSON,
    CompanyDtoToJSONTyped,
} from './CompanyDto';
import type { CitySearchResultDto } from './CitySearchResultDto';
import {
    CitySearchResultDtoFromJSON,
    CitySearchResultDtoFromJSONTyped,
    CitySearchResultDtoToJSON,
    CitySearchResultDtoToJSONTyped,
} from './CitySearchResultDto';

/**
 * 
 * @export
 * @interface MapSearchResponseDto
 */
export interface MapSearchResponseDto {
    /**
     * 
     * @type {Array<CitySearchResultDto>}
     * @memberof MapSearchResponseDto
     */
    cities: Array<CitySearchResultDto> | null;
    /**
     * 
     * @type {Array<CompanyDto>}
     * @memberof MapSearchResponseDto
     */
    companies: Array<CompanyDto> | null;
}

/**
 * Check if a given object implements the MapSearchResponseDto interface.
 */
export function instanceOfMapSearchResponseDto(value: object): value is MapSearchResponseDto {
    if (!('cities' in value) || value['cities'] === undefined) return false;
    if (!('companies' in value) || value['companies'] === undefined) return false;
    return true;
}

export function MapSearchResponseDtoFromJSON(json: any): MapSearchResponseDto {
    return MapSearchResponseDtoFromJSONTyped(json, false);
}

export function MapSearchResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MapSearchResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cities': (json['cities'] == null ? null : (json['cities'] as Array<any>).map(CitySearchResultDtoFromJSON)),
        'companies': (json['companies'] == null ? null : (json['companies'] as Array<any>).map(CompanyDtoFromJSON)),
    };
}

export function MapSearchResponseDtoToJSON(json: any): MapSearchResponseDto {
    return MapSearchResponseDtoToJSONTyped(json, false);
}

export function MapSearchResponseDtoToJSONTyped(value?: MapSearchResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cities': (value['cities'] == null ? null : (value['cities'] as Array<any>).map(CitySearchResultDtoToJSON)),
        'companies': (value['companies'] == null ? null : (value['companies'] as Array<any>).map(CompanyDtoToJSON)),
    };
}

